import React from "react";
import {Nav, Tab} from '@themesberg/react-bootstrap';
import BasePage from "../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import SmartDeviceTable from "../../components/SmartDeviceTable";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";

class SmartDevicePage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      smartDeviceTypes:[],
      defaultActiveTab:"Toolbox",
      activeTab:"Toolbox",
    }
  }

  componentDidMount() {
    super.componentDidMount();
    if(this.props?.navBar?.current){
      this.props.navBar.current.updateNavBarItems([SmartDevicePage.PAGE_CONF])
    }

    this.closePreLoader()
    this.fetchSmartDeviceTypes()
  }

  fetchSmartDeviceTypes = () => {
    let {smartDeviceTypes} = this.state
    this.get(Endpoint.API.SMART_DEVICE_TYPES, {
      params :{
        sortir: "type",
        ascending:true,
      }
    }, null, response=>{
      if(response.code===200){
        smartDeviceTypes = response.data
        this.setState({smartDeviceTypes:smartDeviceTypes},() => this.forceUpdate())
      }else{
        this.props.history.goBack();
      }
    }, false, true)
  }



  render() {
    let {smartDeviceTypes, defaultActiveTab, activeTab, pageElement, totalPage, totalElement, sortOption} = this.state

    return (
        <>
          {
            !isEmpty(defaultActiveTab)?
                (
                    <Tab.Container defaultActiveKey={defaultActiveTab} variant="underline">
                      <Nav fill variant="tabs" className="flex-column flex-sm-row">
                        {
                          smartDeviceTypes.map((item, index)=>(
                              <Nav.Link
                                  eventKey={item.type}
                                  className="mb-sm-3 mb-md-0"
                                  onSelect={eventKey => {
                                    this.setState({activeTab:item.type})
                                  }}
                                  disabled={!item.active}>
                                {item.type}{item.active==true?"":" ("+label.Inactive+")"}
                              </Nav.Link>

                          ))
                        }
                      </Nav>
                      <Tab.Content>
                        {
                          smartDeviceTypes.map((item, index)=>(
                              <Tab.Pane eventKey={item.type} className="py-4">
                                <SmartDeviceTable smartDeviceType={item} show={item.type === activeTab} {...this.props}/>
                              </Tab.Pane>
                          ))
                        }
                      </Tab.Content>

                    </Tab.Container>
                )
                :
                (null)
          }
          {/*<TransactionsTable/>*/}
        </>
    );
  }
}
// export default Object.assign(SmartDevicePage, {ENDPOINT : "/smartDevices"})


const ENDPOINT = "/smartDevices"
const TITLE = label.SmartDevices
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(SmartDevicePage, PAGE)
